import src from "IMAGE";
export default { src, width: 141, height: 141, blurWidth: 0, blurHeight: 0};
